import { Dispatch, SetStateAction } from 'react';
import { Search, X } from 'lucide-react';

interface SearchBarProps {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  placeholder?: string;
  delay?: number;
  className?: string;
}

export default function SearchBar({
  value,
  setValue,
  placeholder = 'Search...',
  className = '',
}: SearchBarProps) {
  return (
    <div
      className={`
        flex items-center gap-2 w-full h-8
        rounded-full border border-white/10
        bg-white/5 px-4 py-3
        backdrop-blur-md
        transition-all duration-200
        focus-within:border-orange-400/50
        focus-within:ring-2
        focus-within:ring-orange-500/20
        ${className}
      `}
    >
      <Search size={18} className="text-white/40 shrink-0" />

      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="
          w-full bg-transparent
          text-sm text-white
          placeholder:text-white/35
          outline-none
        "
      />

      {value && (
        <button
          type="button"
          onClick={() => setValue('')}
          className="text-white/40 hover:text-white transition-colors"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
